const product = {
	set_option: function ({ value }) {
		if (!value) return null;

		const el = document.querySelector(`input[value="${value}"]`);
		if (!el) return null;

		el.checked = true;
	},
	ui: function ({ variant }) {
		if (!variant) return;
		const str_options = variant.options.join(',').toLowerCase();

		// Price
		const price_el = document.getElementById('product-price');
		if (price_el) {
			let formatter = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
				minimumFractionDigits: variant.price % 100 == 0 ? 0 : 2,
				maximumFractionDigits: 2
			});

			price_el.innerText = formatter.format(variant.price / 100);
		}

		// Compare At Price
		const compare_at_price_el = document.getElementById('product-compare-at-price');
		const pairs_compare_at_price_el = document.getElementById('product-pairs-compare-at-price');
		const formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: variant.compare_at_price % 100 == 0 ? 0 : 2,
			maximumFractionDigits: 2
		});

		if (compare_at_price_el && variant.compare_at_price) {
			compare_at_price_el.innerText = formatter.format(variant.compare_at_price / 100);
		} else {
			if (compare_at_price_el) compare_at_price_el.innerText = '';
		}

		if (pairs_compare_at_price_el && variant.compare_at_price) {
			pairs_compare_at_price_el.innerText = formatter.format(variant.compare_at_price / 100);
		} else {
			if (pairs_compare_at_price_el) pairs_compare_at_price_el.innerText = '';
		}

		const variant_input = document.querySelector('input[name="id"]');
		if (variant_input) variant_input.value = variant.id;

		// 2 Pairs Price
		const price_container_el = document.querySelector('.shopify-product-form__price');
		const pairs_price_el = document.getElementById('product-pairs-price');

		if (str_options.indexOf('2 pairs') > -1) {
			price_container_el.classList.add('hidden');
			pairs_price_el.innerText = formatter.format(variant.price / 100);
		} else {
			price_container_el.classList.remove('hidden');
		}

		// Back In Stock
		const back_in_stock_btn = document.getElementById('klaviyo-back-in-stock-button');
		if (back_in_stock_btn) {
			if (variant?.available == false) back_in_stock_btn.classList.add('active');
			if (variant?.available == true) back_in_stock_btn.classList.remove('active');
		}

		// Swiper / Image
		const media_id = variant?.featured_media?.id;
		const media_el = media_id ? document.getElementById(media_id) : null;
		if (media_el && VermontGlove?.product?.swiper) {
			const slide_index = VermontGlove.product.swiper.slides.findIndex(
				(slide) => slide.id == media_id
			);

			if (slide_index != undefined) VermontGlove.product.swiper.slideTo(slide_index, 1000);
		}
	},
	option_select: function () {
		const form = document.getElementById('add-to-cart');
		if (!form) return null;

		const form_data = new FormData(form);
		let options_with_values = {};

		for (const entry of form_data.entries()) {
			const key = entry[0].toLowerCase();
			const value = entry[1];

			if (key != 'quantity' && key != 'add-on' && key != 'monogram' && key != 'id') {
				options_with_values[entry[0]] = value;
			}
		}

		let variant = VermontGlove.product.variants[0];
		if (VermontGlove.product.variants.length > 1) {
			variant = VermontGlove.product.variants.find((v) => {
				const variant_values = v.options.join(',');
				const values = Object.values(options_with_values).join(',');
				if (variant_values == values) return v;
			});
		}

		const params = new URLSearchParams({ variant: variant.id });
		window.history.pushState({}, '', '?' + params.toString());

		product.ui({ variant });
	},
	add_to_cart: async function (event) {
		event.preventDefault();

		const form = event.target;
		if (!form) return null;

		VermontGlove.cart.request(true);

		const { product } = VermontGlove;
		const form_data = new FormData(form);

		let options_with_values = {};
		let quantity = 1;
		let add_ons = {};
		let monogram = null;

		for (const entry of form_data.entries()) {
			const key = entry[0].toLowerCase();
			const value = entry[1];

			if (key == 'quantity') {
				const parsed_quantity = Number.parseInt(value, 10);
				quantity = Number.isFinite(parsed_quantity) && parsed_quantity > 0 ? parsed_quantity : 1;
			}
			if (key == 'add-on') add_ons[value] = true;
			if (key == 'monogram') monogram = value;

			if (key != 'quantity' && key != 'add-on' && key != 'monogram' && key != 'id') {
				options_with_values[entry[0]] = value;
			}
		}

		let variant = product.variants[0];
		if (product.variants.length > 1) {
			variant = product.variants.find((v) => {
				const variant_values = v.options.join(',');
				const values = Object.values(options_with_values).join(',');
				if (variant_values == values) return v;
			});
		}

		const obj = { id: variant.id, quantity };
		if (monogram) obj.properties = { monogram, Monogram: monogram };

		const req = await VermontGlove.api.cart.add(obj);

		const size = req.options_with_values.find((o) => o.name.toLowerCase() == 'size');

		const addons_arr = Object.keys(add_ons);
		if (addons_arr.length) {
			let addon_index = 0;
			const _add_to_cart = async function () {
				if (addon_index >= addons_arr.length) return null;
				const key = addons_arr[addon_index];
				const addon = VermontGlove.addons[key];

				let add_on_req = null;
				if (size && addon.options[0] && addon.options[0].toLowerCase() == 'size') {
					let addon_size = addon.variants.find((v) => v.option1 == size.value && v.available);

					if (addon_size) {
						add_on_req = await VermontGlove.api.cart.add({
							id: addon_size.id,
							quantity: 1,
							properties: { _cartParent: req.key }
						});
					} else {
						add_on_req = await VermontGlove.api.cart.add({
							id: addon.variants[0].id,
							quantity: 1,
							properties: { _cartParent: req.key }
						});
					}
				} else {
					add_on_req = await VermontGlove.api.cart.add({
						id: addon.variants[0].id,
						quantity: 1,
						properties: { _cartParent: req.key }
					});
				}

				addon_index = addon_index + 1;
				await _add_to_cart();
			};

			await _add_to_cart();
		}

		VermontGlove.cart.toggle();
		await VermontGlove.cart.ui();
	}
};

window.VermontGlove = window.VermontGlove || {};
window.VermontGlove.product = window.VermontGlove.product || {};
Object.assign(window.VermontGlove.product, product);

export default product;
